module.exports = __webpack_public_path__ + "static/media/camera-retro.83180a96.svg";